import Alert from "../component/Alert";

const HelpAlert = () => (
  <Alert
    severity="info"
    title="resources.technical-reports.help.alert"
    message="resources.technical-reports.help.alert_message"
  />
);

export default HelpAlert;
